/* A local value search only; Shopify remains responsible for all product filtering. */
if (!customElements.get('cn-filter-search')) {
  customElements.define('cn-filter-search', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.input = this.querySelector('input[type="search"]');
      this.group = this.closest('.js-filter');
      if (!this.input || !this.group) return;
      this.initialized = true;
      this.hidden = false;
      this.input.addEventListener('input', event => { event.stopPropagation(); this.apply(); });
      this.input.addEventListener('search', () => this.apply());
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') event.preventDefault();
        if (event.key === 'Escape' && this.input.value) {
          event.preventDefault();
          event.stopPropagation();
          this.input.value = '';
          this.apply();
        }
      });
      this.apply();
    }

    apply() {
      const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
      const query = normalize(this.input.value);
      let matches = 0;
      this.group.querySelectorAll('[data-cn-filter-row]').forEach(row => {
        const match = !query || normalize(row.dataset.cnFilterLabel || '').includes(query);
        row.hidden = !match;
        if (match) matches += 1;
      });
      this.group.classList.toggle('cn-filter-searching', Boolean(query));
      this.querySelector('.cn-filter-search-empty').hidden = !query || matches > 0;
    }
  });
}
